import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SvgIconComponent } from 'angular-svg-icon';

@Component({
    selector: 'pn-access-denied',
    standalone: true,
    imports: [CommonModule, SvgIconComponent],
    template: `
        <div class="flex min-h-full flex-col items-center justify-center mb:px-8">
            <svg-icon
                svgClass="w-[450px] h-auto mb:w-[250px] mb:h-auto"
                src="/assets/icons/403.svg"
            ></svg-icon>
        </div>
    `,
})
export class AccessDeniedComponent {}
